var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9406 15.316C25.3162 20.6592 21.1015 25.0595 15.7942 25.8452C12.8283 26.3167 10.0185 25.6881 7.83314 24.2737C7.83314 24.2737 5.17946 24.9023 3.61847 25.5309C3.15017 25.6881 2.68188 25.2166 2.83797 24.7451C3.46237 23.1736 4.08677 20.9735 4.08677 20.9735C4.08677 20.9735 4.08677 20.9735 4.08677 20.8163C2.36968 18.3019 1.58918 15.0017 2.21358 11.7015C3.15017 6.98687 6.89654 3.2152 11.5795 2.27229C19.6966 0.543606 26.7211 7.30118 25.9406 15.316Z",
    stroke: "#464646",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00394 8.19017C9.00394 8.19017 9.80197 7.60778 10.4404 8.48137C11.0788 9.35496 11.5576 10.3741 11.5576 10.3741C11.5576 10.3741 11.8768 10.9565 11.398 11.5389C10.9192 12.1213 10.6 12.5581 10.6 12.5581C10.6 12.5581 12.3557 16.0525 16.0266 16.9261L16.9842 16.0525C16.9842 16.0525 17.4631 15.6157 18.1015 15.7613C18.7399 15.9069 20.4956 16.4893 20.4956 16.4893C20.4956 16.4893 21.134 16.7805 20.9744 17.5085L20.1764 19.2556C20.1764 19.2556 19.5379 20.1292 18.2611 19.9836C16.9842 19.838 13.3133 19.4012 10.1212 16.1981C8.20591 14.3053 7.40788 12.5581 7.08867 11.3933C6.92906 10.6653 6.92906 9.93735 7.56749 9.20936C7.8867 8.91816 9.00394 8.19017 9.00394 8.19017Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7318c72830d57773dec960ecbf4ec1de.svg";
export { ForwardRef as ReactComponent };